function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 15 15"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M10.505 5.828l-.951-.926 2.879-2.801.952.926-2.88 2.801zm4.069-3.495a.964.964 0 010 1.389l-4.126 4.014L3.63 14.37a1.03 1.03 0 01-1.428 0L.775 12.981a.964.964 0 010-1.39l7.827-7.615L11.719.944c.197-.192.455-.287.714-.287.258 0 .516.095.714.287l1.427 1.389zM13.288 7.33c.185.302.466.576.777.756a.255.255 0 010 .448c-.31.18-.592.454-.777.756a.269.269 0 01-.461 0 2.28 2.28 0 00-.777-.756.254.254 0 010-.448c.31-.18.59-.454.777-.756a.269.269 0 01.46 0zM6.446 4.393a1.732 1.732 0 00-.464-.452.251.251 0 010-.425 1.73 1.73 0 00.464-.452.267.267 0 01.438 0c.121.175.284.333.463.451a.251.251 0 010 .426 1.732 1.732 0 00-.463.452.267.267 0 01-.438 0zm1.67-2.303a2.285 2.285 0 00-.776-.756.255.255 0 010-.448 2.27 2.27 0 00.777-.757.27.27 0 01.46 0c.187.303.466.576.777.756a.254.254 0 010 .448c-.31.182-.59.455-.777.756a.269.269 0 01-.46 0z",
  fill: "#5F6B72",
  fillRule: "evenodd"
})));